<template>
  <component
    :is="as"
    ref="radice"
    :class="[
      'rounded-2xl',
      solido ? 'glass-solid' : strong ? 'glass-strong' : 'glass',
      glow && !solido && 'glass-glow',
      PADDING[padding],
    ]"
    :data-vetro="solido ? 'solido' : strong ? 'forte' : 'lieve'"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
// Contenitore di vetro leggero per card, grafici e riepiloghi (design-system.md, sezione 2). Un GlassPanel dentro un
// altro passa da solo al vetro pieno (`glass-solid`): mai sfocatura dentro sfocatura. All'hover il bordo si illumina
// verso il mouse, solo nel pannello più esterno (disattivabile con `glow: false`; assente su touch e con «riduci movimento»). È solo grafica: nessun
// ruolo né focus; un pannello cliccabile sarà un UiCard.
type Riempimento = "none" | "sm" | "md" | "lg";

const props = withDefaults(
  defineProps<{
    as?: string;
    // vetro più opaco, per testo secondario e contenuti densi
    strong?: boolean;
    glow?: boolean;
    padding?: Riempimento;
  }>(),
  { as: "div", strong: false, glow: true, padding: "md" },
);

const livello = inject<number>(CHIAVE_LIVELLO_VETRO, 0);
provide(CHIAVE_LIVELLO_VETRO, livello + 1);
const solido = livello > 0;

const radice = ref<HTMLElement | null>(null);
useGlowBordo(radice, props.glow && !solido);

const PADDING: Record<Riempimento, string> = { none: "", sm: "p-3", md: "p-4", lg: "p-6" };
</script>
